import _ from 'lodash'
import { CustomInputs } from '@/components/inputs'


export default {
  props: ['currentStep', 'totalSteps', 'storeNamespace'],
  components: {
    ...CustomInputs,
  },
  data() {
    return {
      model: {}
    }
  },
  created: function() {
    // If currentComponentModel comes from API we got a delay and its value is
    // undefined when this component is created. But we need this funcionality
    // when data is stored in Vuex and we are navigating steps back and forward
    let componentModel = this.currentComponentModel

    if (componentModel) {
      this.model = Object.assign({}, this.model, componentModel)
      this.originalModel = Object.assign({}, this.model, componentModel)
    }
    this.showBackendErrors()
  },
  computed: {
    currentComponentModel: function() {
      return this.$store.getters[this.storeNamespace+'/currentComponentModel']
    },
    currentComponent: function() {
      return this.$store.getters[this.storeNamespace+'/currentComponent']
    },
    isReadOnly: function() {
      // (rootGetters.hasownpropperty('isReadOnly')) ? retur ese : return
      return this.$store.getters[this.storeNamespace+'/isReadOnly']
    },
    seasonStartYear: function() {
      return this.$store.getters[this.storeNamespace+'/seasonStartYear']
    },
  },
  methods: {
    updateCurrentModel: function(model) {
      return this.$store.dispatch(this.storeNamespace+'/updateCurrentModel', model)
    },
    setNextSection: function() {
      return this.$store.dispatch(this.storeNamespace+'/setNextSection')
    },
    toggleNotification: function(notification) {
      return this.$store.dispatch(this.storeNamespace+'/toggleNotification', notification)
    },
    onSubmit: function() {

      if (this.isReadOnly) {
        return new Promise((resolve) => { return resolve() })
      } else {
        this.toggleNotifications()
        return this.updateCurrentModel(this.model)
      }
    },
    toggleNotifications: function() {
      // abstract method: called onSubmit
    },
    widthForRow(farms) {
      return farms.length * 400;
    },
    showBackendErrors() {
      var errors = this.$store.getters[this.storeNamespace+'/sectionBackendErrors']
      if (errors) {
        Object.keys(errors).forEach(key => {
          this.errors.add({field: key, msg: errors[key][0]})
        });
      }
    },
    modelChanged() {
      if (! _.isEqual(this.model, this.originalModel)) {
        this.$emit('model-changed')
      }
    },
    getRowClass: function(items, key, index) {
      if (index == 0) {
        this.lastRowClass = 'colored-table-row'
        return 'colored-table-row'
      }
      let lastItemSeason = this.getRowSeason(items[index-1][key])
      let currentItemSeason = this.getRowSeason(items[index][key])

      if (lastItemSeason != currentItemSeason) {
        if (this.lastRowClass == 'colored-table-row') {
          this.lastRowClass = ''
        } else {
          this.lastRowClass = 'colored-table-row'
        }
      }
      return this.lastRowClass
    },
    getRowSeason: function(str) {
      return str.substring(str.length - 4)
    },
  },
  watch: {
    // If currentComponentModel comes from API we got a delay and its value is
    // undefined when this component is created. So we need a watcher to update
    // this component's model when API call has finished.
    currentComponentModel: function (newModel/*, oldModel*/) {
      this.model = Object.assign({}, this.model, newModel)
      this.originalModel = Object.assign({}, this.model, newModel)
    },
    model: {
      handler: function  ()
      {
        if (! _.isEqual(this.model, this.originalModel))
        {
          this.$emit('model-changed')
        }
      },
      deep: true
    }
  },
};
